import { Validator } from '@vista-digital/validator';
import { ButtonColor } from '../../../subcomponents/button/types/color';
import { ButtonSize } from '../../../subcomponents/button/types/size';
import { defaultFormConfig, formConfigValidatorSchema } from '../../../subcomponents/form/form/types/config';
import { defaultGiftCardPaymentFormValidationConfig, giftCardPaymentFormValidationConfigValidator } from './validation-config';
/**
 * Default field configuration options for the Gift Card Payment Form component.
 */
export const defaultGiftCardPaymentFormConfig = {
    submitButton: Object.assign(Object.assign({}, defaultFormConfig.submitButton), { show: true, color: ButtonColor.Secondary, size: ButtonSize.Small }),
    cancelButton: Object.assign(Object.assign({}, defaultFormConfig.cancelButton), { show: false }),
    showFieldLabels: false,
    validation: defaultGiftCardPaymentFormValidationConfig
};
export const giftCardPaymentFormConfigValidator = Validator.object(Object.assign(Object.assign({}, formConfigValidatorSchema), { validation: giftCardPaymentFormValidationConfigValidator, showFieldLabels: Validator.boolean() }));
